<template>
    <div class="animated fadeIn equipmentList bgV2">
        <b-row>
            <b-col md="12">
                <gofix-tab
                        class="mt-3 contractPropertyTab"
                        :data="contract_tab"
                        :query-param="{id:$route.params.id}"
                        activeKey="service_category"
                        arrows >
                    <template slot="gofixTab:service_category">
                        <div class="equipment row-split">
                            <b-row>
                                <b-col md="3">
                                    <gofix-card title="service category" class="contractTree" v-bind:class="{'run-loading':isLoading}">
                                        <template slot="gofixCard:right_header">
                                            <div class="d-flex justify-content-end align-items-center">
                                                <b-button class="mr-3" :disabled="!$checkRole($accessModule.service_category, 'delete')" @click="removeNode" title="Delete" v-b-tooltip.hover>
                                                    <svg width="20" height="20" viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg">
                                                        <path fill="#999999" d="m256 512c-68.378906 0-132.667969-26.628906-181.019531-74.980469-48.351563-48.351562-74.980469-112.640625-74.980469-181.019531s26.628906-132.667969 74.980469-181.019531c48.351562-48.351563 112.640625-74.980469 181.019531-74.980469s132.667969 26.628906 181.019531 74.980469c48.351563 48.351562 74.980469 112.640625 74.980469 181.019531s-26.628906 132.667969-74.980469 181.019531c-48.351562 48.351563-112.640625 74.980469-181.019531 74.980469zm0-472c-119.101562 0-216 96.898438-216 216s96.898438 216 216 216 216-96.898438 216-216-96.898438-216-216-216zm110 195.980469h-220v40h220zm0 0"/>
                                                    </svg>
                                                </b-button>
                                                <b-button class="mr-3" :disabled="isCheck || !$checkRole($accessModule.service_category, 'create')" @click="addChildNode" title="Create" v-b-tooltip.hover>
                                                    <svg width="20" height="20" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 304.223 304.223" xml:space="preserve">
                                                        <path fill="#999999" d="M152.112,0C68.241,0,0.008,68.244,0.008,152.114c0,83.865,68.233,152.109,152.103,152.109 c83.865,0,152.103-68.244,152.103-152.109C304.215,68.244,235.977,0,152.112,0z M152.112,275.989c-68.32,0-123.891-55.565-123.891-123.875c0-68.326,55.571-123.891,123.891-123.891s123.891,55.565,123.891,123.891C276.003,220.424,220.426,275.989,152.112,275.989z"/>
                                                        <path fill="#999999" d="M221.922,139.186h-56.887V82.298c0-7.141-5.782-12.929-12.923-12.929c-7.141,0-12.929,5.782-12.929,12.929v56.887H82.296c-7.141,0-12.923,5.782-12.923,12.929c0,7.141,5.782,12.923,12.923,12.923h56.882v56.893c0,7.142,5.787,12.923,12.929,12.923c7.141,0,12.929-5.782,12.929-12.923v-56.893h56.882c7.142,0,12.929-5.782,12.929-12.923C234.851,144.967,229.063,139.186,221.922,139.186z"/>
                                            </svg>
                                                </b-button>
                                                <b-dropdown class="btn" right v-b-tooltip.hover title="Setting">
                                                    <b-dropdown-item @click="importSC.open = true" href="javascript:void(0)">Import</b-dropdown-item>
                                                    <b-dropdown-item href="javascript:void(0)" @click="exportSC">Export</b-dropdown-item>
                                                </b-dropdown>
                                            </div>
                                        </template>
                                        <div class="contenAbsolute">
                                            <div class="tree-view-properties">
                                                <tree ref="tree" :data="treeData" :options="opts" @node:clicked="select">
                                                    <div slot-scope="{ node }" class="node-container"> {{ node.text }} </div>
                                                </tree>
                                            </div>
                                        </div>
                                    </gofix-card>
                                </b-col>
                                <b-col md="9" class="pl-md-0">
                                    <!-- class="h-100"  -->
                                    <div class="boxShadow bg-white contractSCFaultType noOverflow mb-0 heig-frame-tab">
                                        <b-row>
                                            <b-col md="9">
                                                <div class="title sm text-dark">{{ breadCrumb ? breadCrumb : '' }}</div>
                                            </b-col>
                                            <b-col md="3">
                                                <div class="flex-justify-end">
                                                <gofix-button
                                                    class="mb-19"
                                                    label="Save"
                                                    @click="save"
                                                    :loading="isAction"
                                                    :disabled="!nodeSelected || $disabledCreateOrUpdate(this.nodeSelected, $accessModule.service_category)"></gofix-button>
                                                </div>
                                            </b-col>
                                        </b-row>
                                        <gofix-card class="pt-20">
                                            <div v-bind:class="{'mt-3':!breadCrumb}">
                                                <b-row>
                                                    <b-col md="6">
                                                        <gofix-form-tree
                                                            label="Master Reference"
                                                            valueFormat="object"
                                                            :options="masterSC"
                                                            placeholder=""
                                                            v-model="master_reference"
                                                            :normalizer="normalizerMaster"
                                                            :loadOptions="loadOptionsMaster"
                                                            search-nested>
                                                        </gofix-form-tree>
                                                    </b-col>
                                                    <b-col md="6">
                                                        <gofix-form-tree
                                                            label="Parents"
                                                            :options="dataparents || []"
                                                            placeholder="Try expanding any folder option..."
                                                            v-model="nodeParent"
                                                            :normalizer="normalizer"
                                                            :loadOptions="loadOptions"
                                                            search-nested>
                                                        </gofix-form-tree>
                                                    </b-col>
                                                    <b-col md="6">
                                                        <gofix-form-input label="Name" desc="Name of the category" v-model="name"></gofix-form-input>
                                                    </b-col>
                                                    <b-col md="6">
                                                        <gofix-form-input v-if="!isRoot" label="Abbreviation" v-model="abbreviation"></gofix-form-input>
                                                    </b-col>
                                                </b-row>
                                                <div>
                                                    <b-col md="6">
                                                    </b-col>
                                                    <!-- <gofix-button
                                                            label="Cancel"
                                                            @click="refresEdit"
                                                            :disabled="!nodeSelected"
                                                            noBorder></gofix-button> -->
                                                </div>
                                            </div>
                                        </gofix-card>
                                        <fault-type :service_category_id="service_category_id" :contract_id="Number($route.params.id)"></fault-type>
                                    </div>
                                </b-col>
                            </b-row>
                        </div>
                    </template>
                </gofix-tab>
            </b-col>
        </b-row>
        <!-- Import File -->
        <modal-import v-model="importSC.open" @upload="uploadFileImport"/>
        <b-modal :no-close-on-backdrop="true" id="modal-Remove" hide-footer hide-header :centered="true" v-model="remove.open">
            <div class="center">Your current category will be <strong>removed</strong>.<br/> Do you want to continue?</div>
            <b-button-group class="btn-group">
                <b-button class="custom-btn" @click="remove.open = false">No</b-button>
                <b-button class="custom-btn" :disabled="remove.loading" @click="removeNodeAction"> 
                    <b-spinner v-if="remove.loading" small type="grow"></b-spinner> Yes
                    </b-button>
            </b-button-group>
        </b-modal>
      <b-modal :no-close-on-backdrop="true" id="modal-Create" :title="modals.export.title" hide-footer :centered="true" v-model="modals.export.open" hide-header-close>
        <b-progress :max="100" height="3rem" show-progress animated>
          <b-progress-bar :value="100">
            <span class="font-size-16">{{modals.export.process}}</span>
          </b-progress-bar>
        </b-progress>
      </b-modal>
    </div>
</template>
<script>
    import tabData from '@/data/_tabs';
    const faultType = () => import('./fault-type')
    import { LOAD_CHILDREN_OPTIONS } from '@riophae/vue-treeselect'
    const simulateAsyncOperation = fn => {
        setTimeout(fn, 500)
    }
    import { mapGetters } from 'vuex';
    import LiquorTree from 'liquor-tree'
    import splitPane from 'vue-splitpane'
    export default {
        name: 'service-category',
        components: {
            [LiquorTree.name]: LiquorTree,
            splitPane,
            faultType
        },
        data() {
            return {
                contract_tab:tabData.client_contract,
                treeData: this.getData(),
                nodeSelected: 0,
                service_category_id: 0,
                opts: {
                    minFetchDelay: 500,
                    fetchData: (node) => {
                        node.isBatch = false;
                        if(node.data.id == this.rootId) {
                            return new Promise((resolve, reject) => {
                                resolve([]);
                            });
                        }
                        return new Promise((resolve, reject) => {
                            global.axios(`api/contracts/${this.$route.params.id}/tree-service-categories/${node.data.id}`, {
                                method: "GET",
                                data: {},
                                headers: {
                                    Accept: "application/json",
                                }
                            })
                                .then(response => {
                                    resolve(response.data.data);
                                })
                                .catch(error => reject(error));
                        });
                    }
                },
                isRoot: true,
                nodeId: '',
                rootId: 0,
                name: '',
                master_reference: null,
                abbreviation: '',
                dataparents: [],
                masterSC: [],
                remove: {
                    open: false,
                    loading: false,
                    data: []
                },
                nodeParent: null,
                nodeParentModal: null,
                replace: function(key, value) {
                    switch (key) {
                        case "children":
                            if (value.length > 0) {
                                return value;
                            } else {
                                return null;
                            }
                            break;
                        default:
                            return value;
                    }
                },
                isCheck: false,
                breadCrumb: '',
                isAction: false,
                isLoading: true,
                importSC: {
                    open: false
                },
              modals:{
                export:{
                  open:false,
                  loading:false,
                  process:'Creating file csv',
                  title: 'Export Data'
                }
              },
            }
        },
        mounted() {
            // this.$refs.tree.$on('tree:mounted', (data) => {
            //     this.$nextTick(() => {
            //         let nodeRoot = this.$refs.tree.find({
            //         data: {
            //             id: this.rootId
            //         }
            //         });

            //         nodeRoot[0].select();
            //         this.select(nodeRoot[0]);
            //         this.dataparents = JSON.parse(JSON.stringify(this.$refs.tree.toJSON(), this.replace));
            //     });
            // })
            // this.$refs.tree.$on('tree:data:received', (data) => {
            //     this.dataparents = JSON.parse(JSON.stringify(this.$refs.tree.toJSON(), this.replace));
            // })
            // this.$refs.tree.$on('node:selected', (data) => {
            //     this.dataparents = JSON.parse(JSON.stringify(this.$refs.tree.toJSON(), this.replace));
            // })
        },
        computed: {
            ...mapGetters({
                ClientContractID: 'ContractController/ClientContractID'
            })
        },
        created() {
            //Load master SC
            //masterSC
            this.$store.dispatch("ServiveCategoryController/getMaster",{id:0})
                .then(response => {
                    this.masterSC = response;
                })
                .catch(err => {
                    console.log(err);
                })
        },
        watch: {
            ClientContractID: function(val, old) {
                if (!val) {
                    return this.$router.push('/v2/contract-client')
                }
                this.nodeSelected = null
                this.refreshServiceCategory();
            },
            nodeSelected: function(val) {
                if(val) {
                    this.service_category_id = val.data && val.data.id ? val.data.id : 0;
                } else {
                    this.service_category_id = this.rootId
                }
            },
            rootId: function(val) {
                if(this.$refs.tree) {
                    this.$refs.tree.$on('tree:mounted', (data) => {
                        this.$nextTick(() => {
                            let nodeRoot = this.$refs.tree.find({
                            data: {
                                id: this.rootId
                            }
                            });

                            nodeRoot[0].select();
                            this.select(nodeRoot[0]);
                            this.dataparents = JSON.parse(JSON.stringify(this.$refs.tree.toJSON(), this.replace));
                        });
                    })
                    this.$refs.tree.$on('tree:data:received', (data) => {
                        this.dataparents = JSON.parse(JSON.stringify(this.$refs.tree.toJSON(), this.replace));
                    })
                    this.$refs.tree.$on('node:selected', (data) => {
                        this.dataparents = JSON.parse(JSON.stringify(this.$refs.tree.toJSON(), this.replace));
                    })
                }
            },
        },
        methods: {
            normalizer(node) {
                if (node.data && node.data.isBatch)
                    return {
                        isDisabled : (this.nodeSelected && this.nodeSelected.data.id == node.data.id) ? true : false,
                        id: node.data.id,
                        label: node.text,
                        children: node.children
                    }
                return {
                    isDisabled : (this.nodeSelected && this.nodeSelected.data && this.nodeSelected.data.id && node && node.data && this.nodeSelected.data.id == node.data.id) ? true : false,
                    id: node.data && node.data.id ? node.data.id : 0,
                    label: node.text,
                    children: undefined
                }
            },
            normalizerMaster(node) {
                if (node.data.isBatch)
                    return {
                        label: node.name,
                    }
                return {
                    label: node.name,
                    children: undefined
                }
            },
            loadOptions({ action, parentNode, callback }) {
                if (action === LOAD_CHILDREN_OPTIONS) {
                    if (parentNode.children) {
                        parentNode.children = parentNode.children;
                        callback();
                        return
                    };
                    if (parentNode.data.isBatch) {
                        global.axios(`api/contracts/${this.$route.params.id}/tree-service-categories/${parentNode.data.id}`, {
                            method: "GET",
                            headers: {
                                Accept: "application/json",
                            }
                        }).then(result => {
                            simulateAsyncOperation(() => {
                                parentNode.children = result.data.data
                                callback();
                            })
                        })
                    } else {
                        parentNode.children = []
                        callback();
                    }
                }
            },
            loadOptionsMaster({ action, parentNode, callback }) {
                if (action === LOAD_CHILDREN_OPTIONS) {
                    if (parentNode.children) {
                        parentNode.children = parentNode.children;
                        callback();
                        return;
                    }
                    if (parentNode.data.isBatch) {
                        this.$store.dispatch("ServiveCategoryController/getMaster",{id:parentNode.id})
                        .then(response => {
                            parentNode.children = response;
                            callback();
                        })
                        .catch(err => {
                            console.log(err);
                            parentNode.children = []
                            callback();
                        })
                    } else {
                        parentNode.children = []
                        callback();
                    }
                }
            },
            getData() {
                return new Promise((resolve, reject) => {
                    global.axios(`api/contracts/${this.$route.params.id}/tree-service-categories/0`, {
                        method: "GET",
                        data: {},
                        headers: {
                            Accept: "application/json",
                        }
                    })
                        .then(response => {
                            this.rootId = response.data.data[0].data.id;
                            this.service_category_id = this.rootId
                            this.isLoading = false;
                            resolve(response.data.data);
                        })
                        .catch(error => reject(error));
                });
            },
            addChildNode() {
                let nodeSelected = null;
                let note_id = null;
                if(this.isRoot) {
                    note_id = this.rootId;
                    if(!this.dataparents) {
                        this.dataparents = JSON.parse(JSON.stringify(this.$refs.tree.toJSON(), this.replace));
                    }
                } 

                if(this.nodeSelected && this.nodeSelected.enabled()) {
                    note_id = this.nodeSelected.data.id;
                }

                let nodeObj = this.$refs.tree.find({
                    data: {
                        id: note_id
                    }
                });
                
                nodeSelected = nodeObj[0];
                var nodeNew = nodeSelected.append({
                    data: {
                        isBatch: false,
                        parent_id: nodeSelected.data.id,
                        node_type: null,
                        status: false
                    },
                    text: 'New node',
                });

                nodeSelected.expand();
                nodeNew.select();
                this.isCheck = true;
                this.isRoot = false;

                // Fix disabled button, don't hide tooltips
                this.$root.$emit('bv::hide::tooltip');

                this.root = nodeSelected.data.text;
                this.nodeParent = nodeSelected.data.id;
                this.nodeParentModal = nodeSelected.data.id;

                this.name = '';
                this.abbreviation = '';
                this.master_reference = null;

                this.nodeId = nodeNew.id;
                this.select(nodeNew, 0);
            },
            async select(node, is_select_from_tree = 1) {
                if(this.nodeSelected && this.nodeSelected.enabled()) {
                    this.nodeSelected.unselect();
                }

                if(!is_select_from_tree && node && node.data && node.data.id) {
                    let nodeObj = this.$refs.tree.find({
                    data: {
                        id: node.data.id
                      }
                    });

                    node = nodeObj[0];
                    node.select();
                }

                if (!node.data.parent_id && node.data.status != false) {
                    let ServiceCategoryInfo = await global.axios(`api/contracts/${this.$route.params.id}/service-categories/${node.data.id}`, {
                        method: "GET",
                        headers: {
                            Accept: "application/json",
                        }
                    });
                    delete ServiceCategoryInfo.data.data.children;
                    node.data = ServiceCategoryInfo.data.data
                }

                this.nodeSelected = node;
                this.nodeParent = node.data.parent_id;
                this.nodeParentModal = node.data.parent_id;
                this.name = node.data.text;
                this.master_reference = node.data.master;
                this.abbreviation = node.data.abbreviation;
                node.data.id == this.rootId ? this.isRoot = true : this.isRoot = false;
                this.breadCrumb = 'N/a';
                if(node.data.id)
                    this.breadCrumb = node.data.breadcrumb + ' >> ' + node.data.name;
                if (this.isRoot)
                    this.breadCrumb = node.data.name;
                this.dataparents = JSON.parse(JSON.stringify(this.dataparents));
            },
            save() {
                if (!this.nodeParent && !this.isRoot)
                    return this.$alertNotification("Parent is a required field", "danger");
                if (!this.name)
                    return this.$alertNotification("Name is a required field", "danger");

                if (this.abbreviation) 
                    this.abbreviation = this.abbreviation.trim();

                if(this.isAction) 
                    return;

                this.isAction =  true;
                let data = {
                    name:         this.name.trim(),
                    abbreviation: this.abbreviation,
                    parent_id:    this.nodeParent,
                    node_type:    "Service Category",
                    contract_id:  this.$route.params.id,
                    master_reference: this.master_reference ? this.master_reference.id : null,
                };

                let api    = 'saveServiveCategory';
                let keyMsg = 'adding';
                if(this.nodeSelected.data.status != false) {
                    api     = 'updateServiveCategory';
                    keyMsg  = 'editing';
                    data.id = this.nodeSelected.data.id;
                }

                this.$store.dispatch(`ServiveCategoryController/${api}`, data)
                .then(result => {
                    let node_data  = result.data.data;
                    node_data.text = node_data.name;
                    let nodeParent = this.$refs.tree.find({
                        data: {
                            id: node_data.parent_id
                        }
                    })

                    this.isCheck = false;
                    delete node_data.children;
                    this.nodeSelected.data = node_data;
                    
                    if (this.nodeParentModal != node_data.parent_id && nodeParent) {
                        const nodeOld = this.nodeSelected;
                        this.nodeSelected.unselect();
                        this.nodeSelected.remove();
                        if (nodeParent && nodeParent[0]) {
                            if(!nodeParent[0].isBatch || nodeParent[0].expanded()) {
                                nodeParent[0].append(nodeOld);
                                nodeParent[0].data.isBatch = true;
                            }
                                
                            if(keyMsg == 'editing') {
                                this.nodeParentModal = nodeParent[0].data.id;
                                this.nodeParent      = nodeParent[0].data.id;
                                nodeParent[0].expand();
                                nodeParent[0].select();
                                this.nodeSelected = nodeParent[0];
                            }
                        }
                    }

                    if(keyMsg == 'adding') {
                        this.isCheck = false;
                        this.nodeSelected.unselect();
                        if (nodeParent) {
                            let node = this.$refs.tree.selected();
                            node.unselect();
                            nodeParent[0].data.isBatch = true;
                            nodeParent.select(true)
                            this.nodeSelected = nodeParent[0];
                            this.select(nodeParent[0], 0);
                            this.nodeSelected.expand();
                        } else
                            this.nodeSelected = null;
                    }

                    this.isAction = false;
                    this.$alertNotification(this.$notificationV2(keyMsg, 'service_category'));
                }).catch(err => {
                    this.isAction = false;
                    if( err.response.data.error && err.response.data.error.message) {
                        let msg = err.response.data.error.message;
                        this.$alertNotification(msg, "danger");
                    }
                })
            },
            removeNode() {
                if (!this.nodeSelected) 
                    return this.$alertNotification("Please select a service category", "danger");
                this.remove.open = true;
            },
            removeNodeAction() {
                this.remove.loading = true;
                if (this.nodeSelected.id == this.nodeId) {
                    this.isCheck = false;
                }
                if (this.nodeSelected.data.status != false)
                    this.$store.dispatch('ServiveCategoryController/removeServiveCategory', {
                        id: this.nodeSelected.data.id,
                        contract_id: this.$route.params.id
                    }).then(response=> {
                        if (this.nodeSelected && this.nodeSelected.data.id == this.rootId) {
                            this.refreshServiceCategory();
                        }
                    })

                if (this.nodeSelected.data.id == this.rootId) {
                    this.nodeSelected.children = [];
                    this.nodeSelected.unselect();
                } else {
                    this.nodeSelected.remove();
                }

                if (this.nodeSelected.data.parent_id == this.rootId) {
                    this.isRoot = true;
                    this.nodeSelected.unselect();
                }

                let nodeParent = this.$refs.tree.find({
                    data: {
                        id: this.nodeSelected.data.parent_id
                    }
                })
                
                if (nodeParent[0] && nodeParent[0].children && nodeParent[0].children.length == 0) {
                    nodeParent[0].data.isBatch = false;
                }

                this.select(nodeParent[0], 0);
                this.nodeParent = null;
                this.breadCrumb = ''
                this.$alertNotification(this.$notificationV2('deleting', 'service_category'));
                this.dataparents = JSON.parse(JSON.stringify(this.$refs.tree.toJSON(), this.replace));
                this.refreshData();
            },
            refreshData() {
                this.name = '';
                this.abbreviation = '';
                this.remove.loading = false;
                this.remove.open = false;
            },
            refresEdit() {
                if (this.nodeSelected) {
                    this.name = this.nodeSelected.data.name
                    this.abbreviation = this.nodeSelected.data.abbreviation
                    this.nodeParent = this.nodeSelected.data.parent_id;
                }
            },
            refreshServiceCategory() {
                this.isLoading = true;
                global.axios(`api/contracts/${this.$route.params.id}/tree-service-categories/0`, {
                    method: "GET",
                    headers: {
                        Accept: "application/json",
                    }
                }).then(response => {
                    this.isLoading = false;
                    response.data.data[0].state.selected = true;
                    this.rootId = response.data.data[0].data.id;
                    this.service_category_id = this.rootId
                    this.isRoot = true
                    this.name = ''
                    this.isCheck = false;
                    this.$refs.tree.tree.setModel(response.data.data);
                })
                .catch(error => {
                    this.isLoading = false;
                });
            },
            async uploadFileImport(callback){
                const { file, resolve, reject } = await callback();
                this.$store.dispatch(`ServiveCategoryController/uploadFileServiceCategory`, {
                    contract_id: this.$route.params.id,
                    fileServiceCategory: file
                })
                .then(response => {
                    this.refreshServiceCategory();
                    resolve({
                        result: response.data.data,
                        msg_success: this.$notificationV2('importing', 'service_category')
                    });
                })
                .catch(err => {
                    reject(err);
                })
            },
            async exportSC() {
              let contract_id = this.$route.params.id;
              let that = this;
              this.modals.export.open = true;
              this.modals.export.process = "Creating file csv";
              await global.axios(`api/contracts/${contract_id}/service-categories/export`, {
                method: "GET",
                responseType: 'blob',
                onDownloadProgress (progress) {
                  that.modals.export.process = "Downloading";
                }
              })
                  .then(response => {
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', 'ServiveCategory.csv'); //or any other extension
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                    this.modals.export.open = false
                  })
                  .catch(error => {
                    this.modals.export.open = false
                    console.log(error);
                  });
            }
        }
    }
</script>
